import styles from '../styles/gnb.scss';

export function dispatchToggleGameMenu(wrapper: HTMLElement): () => void {
  const gnb = wrapper.querySelector(`.${styles.gnb}`);
  const gameMenu = wrapper.querySelector(`.${styles.menuGame}`);
  const itemList = wrapper.querySelector(`.${styles.itemList}`);

  if (!gnb || !gameMenu || !itemList) {
    return () => {};
  }

  const onEnter = () => {
    gnb.className = `${styles.gnb} ${styles.active}`;
  };

  const onLeave = () => {
    gnb.className = styles.gnb;
  };

  gameMenu.addEventListener('mouseenter', onEnter, false);
  itemList.addEventListener('mouseenter', onEnter, false);

  gameMenu.addEventListener('mouseleave', onLeave, false);
  itemList.addEventListener('mouseleave', onLeave, false);

  return () => {
    gameMenu.removeEventListener('mouseenter', onEnter, false);
    itemList.removeEventListener('mouseenter', onEnter, false);

    gameMenu.removeEventListener('mouseleave', onLeave, false);
    itemList.removeEventListener('mouseleave', onLeave, false);
  };
}
